import lunr from 'lunr';

/**
 * searches a store of data and outputs the result
 * @param {object} searchStore - each property requires 'title' and 'content' properties
 ** to map data correctly
 * @param {string} searchString
 * @returns resultsBox
 */

export default function search(searchStore, searchString) {
  // going to store a hash of stemmed word to list of original words
  let reverseStem = [];

  function reverseStemIndexBuilder(token) {
    const stemmed = lunr.stemmer(token);

    reverseStem = reverseStem.concat([token, stemmed]);

    return stemmed;
  }

  lunr.tokenizer.registerFunction(reverseStemIndexBuilder, 'stemmer');

  if (searchString) {
    // Initalize lunr with the fields it will be searching on. Title has
    // a boost of 10 and category a boost of 20 to indicate matches on these
    // fields are more important.
    const idx = lunr(function lunrFunc() {
      this.field('id');
      this.field('title', { boost: 10 });
      this.field('content');
      this.field('category', { boost: 20 });
      this.field('sub_category', { boost: 30 });
    });

    Object.keys(searchStore).forEach(key => { // Add the data to lunr
      idx.add({
        id: key,
        title: searchStore[key].title,
        content: searchStore[key].content,
        category: searchStore[key].category,
        sub_category: searchStore[key].sub_category,
      });
    });

    // idx is your instance of a lunr index
    // we can remove the existing stemmer since reverseStemIndexBuilder
    // already returns a stemmed token
    idx.pipeline.remove(lunr.stemmer);
    idx.pipeline.add(reverseStemIndexBuilder);


    const result = idx.search(searchString);

    return {
      result,
      stem: reverseStem,
    };
  }
  return false;
}



// WEBPACK FOOTER //
// ./utils/search.js